export default {"src":"/_next/static/media/icon_store_calendar.ff733c33.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};